import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface OutcomeItem {
  title: string;
  description: string;
}

interface LabItem {
  title: string;
  image: string;
  description: string;
  equipment?: string;
}

interface ProgrammeItem {
  sno: number;
  name: string;
  duration: string;
}

interface ActivityItem {
  sno: number;
  activity: string;
  date: string;
  description: string;
}

interface AssociationPhotoItem {
  title: string;
  image: string;
  description: string;
}

interface MouItem {
  sno: number;
  company: string;
  description: string;
  status: string;
}
interface PlacementItem {
  sno: number;
  studentName: string;
  designation: string;
  company: string;
}
interface NptelItem {
  sno: number;
  date: string;
  staffName: string;
  details: string;
  remarks: string;
} 
interface PublicationItem {
  sno: number;
  journal: string;
  paperTitle: string;
  authorName: string;
  indexing: string;
  year: string;
}
interface IndustrialVisitTableItem {
  sno: number;
  organization: string;
  date: string;
}

interface VisitItem {
  title: string;
  image: string;
  description: string;
}

interface SupervisorItem {
  sno: number;
  referenceNo: string;
  name: string;
  department: string;
  designation: string;
  specialization: string;
  contactNumber: string;
}

interface ValueAddedCourseItem {
  sno: number;
  courseName: string;
  courseDetails: string;
  commenceDate: string;
}

interface AchievementItem {
  sno: number;
  date: string;
  studentName: string;
  details: string;
  remarks: string;
}
interface AlumniItem {
  image: string;
  alt: string;
  batch: string;
  name: string;
  designation: string;
  organization: string;
  location?: string;
}
interface MouPhotoItem {
  image: string;
  alt: string;
  note?: string;
}

@Component({
  selector: 'app-courses-grid-style-one-columns-three-page',
  templateUrl: './courses-grid-style-one-columns-three-page.component.html',
  styleUrls: ['./courses-grid-style-one-columns-three-page.component.scss']
})
export class CoursesGridStyleOneColumnsThreePageComponent implements OnInit, OnDestroy {
  isToggled = false;
  selectedTab = 'tab1';
  activeContent = 'default';
  private themeSub?: Subscription;

  departmentName = 'Department of Mechanical Engineering';
  establishedYear = '2009';
  programmeSummary = '1 UG, 1 PG & Ph.D.';
  contactEmail = 'hodmech@fmcet.ac.in';
  researchCertificateImage = 'assets/img/mech/cr.png';

 admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,M.E. (CSE), M.E. (Embedded System Technologies),M.E. (Thermal Engineering), M.E. (Environmental Engineering)';
      
  tabs: DepartmentTab[] = [
    { id: 'tab1', label: 'About the Department' },
    { id: 'tab2', label: 'Vision & Mission' },
    { id: 'tab3', label: "PEO's" },
    { id: 'tab4', label: 'POs & PSOs' },
    { id: 'tab14', label: 'Programme Offered' },
    { id: 'tab5', label: 'Laboratory Facilities' },
    { id: 'tab6', label: 'Association & Club Activities' },
    { id: 'tab7', label: "MoU's" },
    { id: 'tab8', label: 'Placement Record' },
    { id: 'tab9', label: 'Industrial Visit' },
    { id: 'tab11', label: 'Value Added Courses' },
    { id: 'tab12', label: 'Alumni' },
    { id: 'tab13', label: 'Achievements' },
    { id: 'tab15', label: 'NPTEL' },
    { id: 'tab10', label: 'Research' }
  ];

  aboutParagraphs: string[] = [
    'The Department of Mechanical Engineering at Fatima Michael College of Engineering and Technology was established along with the institution in 2009 with an intake of 60 students.',
    'The postgraduate programme in Thermal Engineering was started during the academic year 2011–2012 with an intake of 18 students. The department is affiliated to Anna University, Chennai and approved by AICTE, New Delhi.',
    'The department is one of the approved Research Centres of Anna University, Chennai. It consistently maintains good academic records and strives to produce quality mechanical engineers with strong technical knowledge and professional values.'
  ];

  quickFacts: FactItem[] = [
    { title: 'Established', value: '2009' },
    { title: 'Affiliation & Approval', value: 'Anna University, Chennai and AICTE, New Delhi' },
    { title: 'Postgraduate Programme', value: 'M.E. Thermal Engineering started in 2011–2012' },
    { title: 'Research Recognition', value: 'Approved Research Centre under Anna University, Chennai' }
  ];

  visionText =
    'To provide world class engineering education and scientific research to build up mechanical engineers for globalized social development.';

  missionPoints: string[] = [
    'To impart quality technical education through eminent faculty to create efficient mechanical engineers.',
    'To promote effective collaboration with esteemed institutes and industries for technical knowledge transfer and research activities.',
    'To develop skills aligned with recent technological movements and promote co-curricular and extracurricular activities to enhance employability and entrepreneurship.',
    'To develop responsible citizenship through awareness and acceptance of ethical values.'
  ];

  peos: string[] = [
    'Effectuating success in careers by exploring design, digital and computational analysis of engineering systems, experimentation and testing, smart manufacturing, technical services, and research.',
    'Amalgamating effectively with stakeholders to update and improve core competencies and abilities to ethically compete in the ever-changing multicultural global enterprise.',
    'To encourage multidisciplinary research and development to foster advanced technology, and to nurture innovation and entrepreneurship in order to compete successfully in the global economy.',
    'To globally share and apply technical knowledge to create new opportunities that proactively advance society through team efforts and solve challenging technical, environmental, and societal problems.',
    'To create world class mechanical engineers capable of practicing engineering ethically with a solid vision to become great leaders in academia, industries, and society.'
  ];

  programOutcomes: OutcomeItem[] = [
    {
      title: 'Engineering Knowledge',
      description:
        'Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.'
    },
    {
      title: 'Problem Analysis',
      description:
        'Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using first principles of mathematics, natural sciences, and engineering sciences.'
    },
    {
      title: 'Design / Development of Solutions',
      description:
        'Design solutions for complex engineering problems and design system components or processes that meet specified needs with appropriate consideration for public health, safety, and cultural, societal, and environmental considerations.'
    },
    {
      title: 'Conduct Investigations of Complex Problems',
      description:
        'Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of information to provide valid conclusions.'
    },
    {
      title: 'Modern Tool Usage',
      description:
        'Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools including prediction and modeling to complex engineering activities with an understanding of their limitations.'
    },
    {
      title: 'The Engineer and Society',
      description:
        'Apply reasoning informed by contextual knowledge to assess societal, health, safety, legal, and cultural issues and the consequent responsibilities relevant to professional engineering practice.'
    },
    {
      title: 'Environment and Sustainability',
      description:
        'Understand the impact of professional engineering solutions in societal and environmental contexts, and demonstrate knowledge of and the need for sustainable development.'
    },
    {
      title: 'Ethics',
      description:
        'Apply ethical principles and commit to professional ethics, responsibilities, and norms of engineering practice.'
    },
    {
      title: 'Individual and Teamwork',
      description:
        'Function effectively as an individual, and as a member or leader in diverse teams and multidisciplinary settings.'
    },
    {
      title: 'Communication',
      description:
        'Communicate effectively on complex engineering activities with the engineering community and society at large through reports, design documentation, presentations, and clear instructions.'
    },
    {
      title: 'Project Management and Finance',
      description:
        'Demonstrate knowledge and understanding of engineering and management principles and apply these to individual work and team-based project management in multidisciplinary environments.'
    },
    {
      title: 'Life-long Learning',
      description:
        'Recognize the need for, and have the preparation and ability to engage in independent and life-long learning in the broadest context of technological change.'
    }
  ];
publications: PublicationItem[] = [
  {
    sno: 1,
    journal: 'Polymer Composites',
    paperTitle:
      'Structural, Thermal, and Mechanical Characterization of Vinyl Ester Composites Reinforced With Juglans regia Seed Shell Filler',
    authorName: 'Mr. M. Selvakumar',
    indexing: 'SCI',
    year: '2025'
  },
  {
    sno: 2,
    journal: 'Thiagarajar Journal of Engineering, Science, Design and Technology',
    paperTitle:
      'Mechanical Properties of Agave Americana Fiber Reinforced Polyester Composite',
    authorName: 'Mr. M. Prabakaran',
    indexing: '-',
    year: '2025'
  },
  {
    sno: 3,
    journal: 'Engineering Horizons; Innovations Advancement and Sustainability',
    paperTitle:
      'Failure Analysis of Automotive Pumper Using Finite Element Method',
    authorName: 'Mr. M. Prabakaran',
    indexing: '-',
    year: '2025'
  },
  {
    sno: 4,
    journal: 'International Conference on Innovation for Sustainability',
    paperTitle: 'Study of Line Contact Fatigue Failures',
    authorName: 'Mr. H. Ganesh',
    indexing: '-',
    year: '2025'
  },
  {
    sno: 5,
    journal: 'Mechanical Characterization of Friction Stir Welding using Dissimilar Materials',
    paperTitle:
      'Effects of Polytetrafluroethelene (PTFE) Content on Mechanical Properties of Poly Ethylene Vinyl Acetate (PEVA) Polymer Composite',
    authorName: 'Mr. M. Prabakaran',
    indexing: '-',
    year: '2024'
  },
  {
    sno: 6,
    journal: 'Mechanical Characterization of Friction Stir Welding using Dissimilar Materials',
    paperTitle:
      'Mechanical Characterization of Friction Stir Welding using Dissimilar Materials',
    authorName: 'B. M. Gnanasekaran',
    indexing: 'SCOPUS',
    year: '2024'
  },
  {
    sno: 7,
    journal: 'Chalcogenide Letters',
    paperTitle:
      'Experimental Investigations for the Effect of Sonication Time on Nanophase Change Material (Sodium Carbonate Decahydrate with Alumina Nanoparticles) Used in Solar Energy',
    authorName: 'Dr. P. Paul Pandian',
    indexing: 'SCOPUS',
    year: '2021'
  },
  {
    sno: 8,
    journal: 'Clean Technologies and Environmental Policy',
    paperTitle:
      'Structural Analysis of a Domestic Liquefied Petroleum Gas Cylinder Using Banana Fiber Composites Materials as per ASME Standards Using FEA Software',
    authorName: 'P. Paul Pandian',
    indexing: 'SCOPUS',
    year: '2020'
  },
  {
    sno: 9,
    journal: 'Construction and Building Materials',
    paperTitle:
      'Cellulosic Fiber Based Hybrid Composites: A Comparative Investigation into their Structurally Influencing Mechanical Properties',
    authorName: 'B. Raja Mohamed Rabi',
    indexing: 'SCOPUS',
    year: '2020'
  }
];
  programSpecificOutcomes: OutcomeItem[] = [
    {
      title: 'PSO 1',
      description:
        'Apply the knowledge gained in Mechanical Engineering for design, development, and manufacture of engineering systems.'
    },
    {
      title: 'PSO 2',
      description:
        'Apply the knowledge acquired to investigate research-oriented problems in Mechanical Engineering with due consideration for environmental and social impacts.'
    },
    {
      title: 'PSO 3',
      description:
        'Use engineering analysis and data management tools for effective management of multidisciplinary projects.'
    }
  ];

  programmes: ProgrammeItem[] = [
    { sno: 1, name: 'B.E. Mechanical Engineering', duration: '4 Years' },
    { sno: 2, name: 'M.E. Thermal Engineering', duration: '2 Years' },
    { sno: 3, name: 'Ph.D.', duration: 'Part Time / Full Time' }
  ];

  labs: LabItem[] = [
    {
      title: 'Manufacturing Technology Lab',
      image: 'assets/img/mech/l1.png',
      description:
        'Manufacturing Technology Laboratory is a well-equipped laboratory which provides hands-on training in manufacturing processes.',
      equipment:
        'Lathe Machines, Surface Grinding Machine, Cylindrical Grinding Machine, Centerless Grinding Machine, Universal Drilling Machine, Universal Milling Machine, Shaper Machine, Tool and Cutter Machine'
    },
    {
      title: 'Strength of Materials Lab',
      image: 'assets/img/mech/l2.png',
      description:
        'Strength of Materials Lab helps students learn about the mechanical behaviour of materials under load and perform experiments to measure their properties.',
      equipment:
        'Universal Testing Machine, Shear Test Attachment, Torsion Machine, Rockwell Hardness, Brinell Hardness, Spring Machine, Pendulum Impact Machine'
    },
    {
      title: 'Fluid Mechanics and Machinery Laboratory',
      image: 'assets/img/mech/l3.png',
      description:
        'Provides students with hands-on experience and practical knowledge related to fluid machines, their design, operation, and performance while developing essential engineering skills.',
      equipment:
        'Venturi Meter Test Rig, Orifice Meter Test Rig, Rotameter Test Rig, Centrifugal Pump Test Rig, Submersible Pump Test Rig, Reciprocating Pump Test Rig, Gear Pump Test Rig'
    },
    {
      title: 'I.C. Engines Laboratory',
      image: 'assets/img/mech/l4.png',
      description:
        'Enhances understanding of internal combustion engines, focusing on mechanics, performance, and emissions through experiments and practical study.',
      equipment:
        'Four Stroke Diesel Engine Cut Section Model, Two Stroke Petrol Engine Cut Section Model, Redwood Viscometer, Flash and Fire Point Apparatus, 4 Stroke Diesel Engine with Retardation Test'
    },
    {
      title: 'Heat Transfer Laboratory',
      image: 'assets/img/mech/l5.png',
      description:
        'Supports practical understanding of conduction, convection, and radiation in various thermal systems for undergraduate and postgraduate students.',
      equipment:
        'Thermal Conductivity Apparatus, Stefan Boltzmann Apparatus, Lagged Pipe, Heat Transfer by Forced Convection Apparatus, Natural Convection Apparatus'
    },
    {
      title: 'Metrology and Measurements Laboratory',
      image: 'assets/img/mech/l6.png',
      description:
        'A well-equipped laboratory that provides hands-on experience with various measuring instruments used in industries.',
      equipment:
        'Tool Maker’s Microscope, Comparator, Sine Bar, Gear Tooth Vernier Caliper, Floating Gauge Micrometer'
    }

  ];

  associationActivities: ActivityItem[] = [
    {
      sno: 1,
      activity: 'Guest Lecture on Heat and Mass Transfer',
      date: '24.03.2026',
      description: ''
    },
    {
      sno: 2,
      activity: 'Seminar on “Advanced Technologies in Aerospace and Automotives”',
      date: '04.03.2026',
      description: ''
    },
    {
      sno: 3,
      activity: 'Hands-on Workshop on CNC Milling',
      date: '09.02.2026',
      description: ''
    },
    {
      sno: 4,
      activity: 'Seminar on Welding Inspection Techniques',
      date: '13.02.2026',
      description: ''
    },
    {
      sno: 5,
      activity: 'Seminar on Waste Management in Smart Factories',
      date: '21.01.2026',
      description: ''
    },
    {
      sno: 6,
      activity: 'Seminar on Integration of CAD and VR in Product Design',
      date: '21.01.2026',
      description: ''
    },
    {
      sno: 7,
      activity: 'Seminar on Characteristics Evaluation of Aluminum Metal Matrix Composite',
      date: '20.01.2026',
      description: ''
    },
    {
      sno: 8,
      activity: 'Guest Lecture on Mechanics of Machines',
      date: '10.11.2025',
      description: ''
    },
    {
      sno: 9,
      activity: 'Guest Lecture on Design of Machine Elements',
      date: '07.10.2025',
      description: ''
    },
    {
      sno: 10,
      activity: 'Seminar on Recent Trends in CAD/CAM',
      date: '15.09.2025',
      description: ''
    },
    {
      sno: 11,
      activity: 'Entrepreneurship and Innovation Development “From Idea to Startup Success”',
      date: '04.09.2025',
      description: ''
    },
    {
      sno: 12,
      activity: 'Session on IPR Filing Methodology',
      date: '22.08.2025',
      description: ''
    },
    {
      sno: 13,
      activity: 'Seminar on “Advanced Machining Process”',
      date: '14.08.2025',
      description: ''
    }
  ];

  associationActivityPhotos: AssociationPhotoItem[] = [
    {
      title: 'Session on IPR Filing Methodology',
      image: 'assets/img/mech/aa1.jpeg',
      description:
        'The Department of Mechanical Engineering & R & D Cell jointly organized a seminar on “IPR Filling Methodology”. The Resource Person was Dr. P. K. Parthiban, Associate Professor, Department of Mechanical Engineering, Kamaraj College of Engineering & Technology, Virudhunagar on 22.08.2025.'
    },
    {
      title: 'From Idea to Startup Success',
      image: 'assets/img/mech/aa2.jpeg',
      description:
        'The Department of Mechanical Engineering organised a Seminar on “From Idea to Start-up Success” for Automobile and Mechanical Engineering students on 04.09.2025. The Resource Person was Mr. R. Praveen Kumar, Founder & CEO, Ippo Padi Edutech Pvt Ltd, Madurai.'
    },
    {
      title: 'Guest Lecture on Heat and Mass Transfer',
      image: 'assets/img/mech/aa3.jpeg',
      description:
        'The Department of Mechanical Engineering organised a Guest Lecture on “Heat and Mass Transfer”. The Resource Person was Mr. D. Vinoth Raj, AP/MECH, Sudharsan Engineering College, Pudukkottai, for Automobile and Mechanical Engineering students on 24.03.2026.'
    }
  ];

mous: MouItem[] = [
  {
    sno: 1,
    company: 'Ctrl+P Pvt Ltd',
    description:
      'MoU to provide awareness and incubation opportunities for students and faculty; supports development of startup products through mentorship, technical guidance, and incubation facilities.',
    status: 'Signed'
  },
  {
    sno: 2,
    company: 'Madurai District Tiny and Small Scale Industries Association',
    description:
      'Collaboration to enhance industry-academic relationship and provide job and training opportunities.',
    status: 'Signed'
  },
  {
    sno: 3,
    company: 'MeckTeck Research Foundation',
    description:
      'Collaboration to strengthen practical exposure, research, and innovation opportunities for students.',
    status: 'Signed'
  },
  {
    sno: 4,
    company: 'Dimension Technologies',
    description:
      'MoU to provide training, skill development, and industry exposure for students.',
    status: 'Signed'
  },
  {
    sno: 5,
    company: 'Focus Technologies',
    description:
      'Collaboration aimed at fostering industry-academic interaction, internships, and career opportunities.',
    status: 'Signed'
  }
];
mouPhotos: MouPhotoItem[] = [
  {
    image: 'assets/img/mech/mou1.jpg',
    alt: 'MoU Signing Photo',
    note: 'MoU signed with Ctrl+P Pvt Ltd for student startup incubation at FMCET'
  }
];
  placementRecords: PlacementItem[] = [
    {
      sno: 1,
      studentName: 'ABINESH R',
      designation: 'Quality Engineer',
      company: 'Rane Madras Limited, Chennai'
    },
    {
      sno: 2,
      studentName: 'DINESH T',
      designation: 'Quality Engineer',
      company: 'Rane Madras Limited, Chennai'
    },
    {
      sno: 3,
      studentName: 'DINESHKUMAR K',
      designation: 'Quality Engineer',
      company: 'Rane Madras Limited, Chennai'
    },
    {
      sno: 4,
      studentName: 'GOPINATH M',
      designation: 'Quality Engineer',
      company: 'Rane Madras Limited, Chennai'
    },
    {
      sno: 5,
      studentName: 'KARTHIKSARAN R',
      designation: 'Quality Engineer',
      company: 'Rane Madras Limited, Chennai'
    },
    {
      sno: 6,
      studentName: 'MOHAMED MUHSHIN A',
      designation: 'Quality Engineer',
      company: 'Rane Madras Limited, Chennai'
    },
    {
      sno: 7,
      studentName: 'POOMANI M',
      designation: 'Data Analyst',
      company: 'Besant Technologies, Chennai'
    },
    {
      sno: 8,
      studentName: 'SELLARASU A',
      designation: 'Quality Engineer',
      company: 'Rane Madras Limited, Chennai'
    }
  ];

  industrialVisitTable: IndustrialVisitTableItem[] = [
    {
      sno: 1,
      organization: 'Industrial Training Centre, Muthupatti, Sivagangai',
      date: '02.03.2026'
    },
    {
      sno: 2,
      organization: 'Golden Rock Central Railway Workshop, Trichy',
      date: '20.02.2026'
    },
    {
      sno: 3,
      organization: 'CECRI, Karaikudi',
      date: '26.09.2025'
    }
  ];

  industrialVisits: VisitItem[] = [
    {
      title: 'Industrial Training Centre, Muthupatti, Sivagangai',
      image: 'assets/img/mech/iv2.png',
      description:
        'On 2nd March 2026, students undertook an industrial visit to the Industrial Training Centre, Sivagangai.'
    },
    {
      title: 'Golden Rock Central Railway Workshop, Trichy',
      image: 'assets/img/mech/iv1.png',
      description:
        'On 20th February 2026, students undertook an industrial visit to the Golden Rock Central Railway Workshop, a prominent unit of Indian Railways, located in Tiruchirappalli.'
    },
    {
      title: 'CECRI, Karaikudi',
      image: 'assets/img/mech/iv3.png',
      description:
        'Students visited CECRI, Karaikudi on 26th September 2025 as part of their industrial exposure and experiential learning.'
    }
  ];

  supervisors: SupervisorItem[] = [
    {
      sno: 1,
      referenceNo: '2520033',
      name: 'Dr. P. Nelson Raja, B.E., M.E., Ph.D.',
      department: 'Mechanical Engineering',
      designation: 'Principal & Professor',
      specialization:
        'Industrial Engineering, Quality Engineering, Energy Engineering, Manufacturing Engineering',
      contactNumber: '9942982321'
    },
    {
      sno: 2,
      referenceNo: '2820030',
      name: 'Dr. P. Paul Pandian, B.E., M.Tech., Ph.D.',
      department: 'Mechanical Engineering',
      designation: 'Professor',
      specialization:
        'Flexible Manufacturing, Scheduling, Composite Materials, Natural Fibers',
      contactNumber: '9843481546'
    }
  ];

  valueAddedCourses: ValueAddedCourseItem[] = [
    {
      sno: 1,
      courseName: 'Solid Works',
      courseDetails:
        'This value-added course helps students learn 3D design using Solid Works, making it easier to understand engineering concepts visually.',
      commenceDate: '19.01.26'
    }
  ];

  alumniProfile = {
    name: 'John Doe',
    batch: 'Batch of 2010',
    description:
      'John Doe is one of the most distinguished alumni of our institution. Currently serving as the CTO of a leading tech firm, he has been instrumental in driving innovations in artificial intelligence and machine learning. His achievements continue to inspire students to pursue excellence in engineering and leadership.',
    quote:
      'The journey at this institution laid the foundation for my professional success and personal growth.'
  };

  achievements: AchievementItem[] = [
    {
      sno: 1,
      date: '06.02.2026 to 07.02.2026',
      studentName: 'Alagumalaikannan K (III Year)',
      details: '“Draftathon” Symposium @ Solamalai College of Engineering',
      remarks: 'First Prize'
    },
    {
      sno: 2,
      date: '06.02.2026 to 07.02.2026',
      studentName: 'Rajashimman J (III Year)',
      details: '“Pick and Talk” Symposium @ Solamalai College of Engineering',
      remarks: 'Second Prize'
    },
    {
      sno: 3,
      date: '26.08.2025',
      studentName: 'M. Poomani (IV Year)',
      details:
        '“Data Decode Challenge”, NEXORA 25 - State Level Technical Symposium @ Mangayarkarasi College of Engineering, Madurai',
      remarks: 'III Prize'
    },
    {
      sno: 4,
      date: '14.03.2025',
      studentName: 'M. Poomani (III Year)',
      details: 'Paper Presentation in State Level Technical Symposium @ Syed Ammal Engineering College',
      remarks: 'First Prize'
    },
    {
      sno: 5,
      date: '14.03.2025',
      studentName: 'M. Chandru (II Year)',
      details: 'Mechtronz 2k25 - (RC Cars & Technical Quiz) @ Syed Ammal Engineering College',
      remarks: 'Second Prize'
    },
    {
      sno: 6,
      date: '20.02.2025',
      studentName: 'R. Abinesh (II Year)',
      details: 'Just a Minute - State Level Technical Symposium @ NPR College of Engineering and Technology',
      remarks: 'Second Prize'
    }
  ];
  nptelRecords: NptelItem[] = [
  {
    sno: 1,
    date: 'July-Oct 2025',
    staffName: 'Mr R Pandi',
    details: 'OBE & Accreditation NPTEL course',
    remarks: 'Elite Silver'
  },
  {
    sno: 2,
    date: 'July-Oct 2025',
    staffName: 'Mr H Ganesh',
    details: 'OBE & Accreditation NPTEL course',
    remarks: 'Elite Silver'
  },
  {
    sno: 3,
    date: 'July-Oct 2025',
    staffName: 'Mrs S Sundaravalli',
    details: 'OBE & Accreditation NPTEL course',
    remarks: 'Elite Silver'
  },
  {
    sno: 4,
    date: 'July-Oct 2025',
    staffName: 'Mr M Kathiravan',
    details: 'OBE & Accreditation NPTEL course',
    remarks: 'Elite'
  },
  {
    sno: 5,
    date: 'Aug-Oct 2025',
    staffName: 'Mr M Selvakumar',
    details: 'OBE & Accreditation NPTEL course',
    remarks: 'Elite'
  }
];
alumniRecords: AlumniItem[] = [
  {
    image: 'assets/img/mech/a1.jpeg',
    alt: 'Alumni - A. Vigneswaran',
    batch: '2016-20',
    name: 'A. Vigneswaran',
    designation: 'Design Engineer',
    organization: 'Quest Global Engineering Service Pvt. Ltd, Chennai'
  },
  {
    image: 'assets/img/mech/a2.jpeg',
    alt: 'Alumni - R. Balamurugan',
    batch: '2012-16',
    name: 'R. Balamurugan',
    designation: 'Installation Engineer',
    organization: 'GE T&D India Limited, Kolkata'
  },
  {
    image: 'assets/img/mech/a3.jpeg',
    alt: 'Alumni - Mr. Nidhin Ninan Thomas',
    batch: '2013-17',
    name: 'Mr. Nidhin Ninan Thomas',
    designation: 'Production Operative',
    organization: 'Phinia Inc, England – United Kingdom'
  }
];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeSub = this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Department Profile';
  }

  setContent(content: string): void {
    this.activeContent = content;
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
  }
}